// extracted by mini-css-extract-plugin
export var completionBody = "_mr-2";
export var completionCard = "_mr-0";
export var completionFooter = "_mr-3";
export var completionTitle = "_mr-1";